<template>
  <div class="table_container">
    <common-layout>
      <div slot="header">
        <h3>视频学习</h3>
      </div>
      <div slot="container">
        <div class="handle-box">
          <el-button
            style="background: #623AA2;border: none;"
            type="success"
            size="medium"
            icon="el-icon-plus"
            class="handle-del mr10"
            @click="addNews()"
          >新增视频</el-button>
          <el-button
            type="danger"
            size="medium"
            icon="el-icon-delete"
            class="handle-del mr10"
            @click="deleteAll()"
          >批量删除</el-button>
          <el-input
            style="width:30%;margin:0 10px"
            placeholder="视频关键词"
            v-model="title_keyWord"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <el-select v-model="type_shu_select" @change="selectChange">
            <el-option value label="全部"></el-option>
            <el-option value="1" label="学习课程"></el-option>
            <el-option value="2" label="点播课程"></el-option>
          </el-select>
          <label style="margin: 0 10px; line-height: 40px; min-width: 60px">发布平台:</label>
            <el-select
              style="width: 300px"
              v-model="srelease"
              clearable
              placeholder="请选择发布平台"
              @change="search"
            >
              <el-option label="双平台" :value="1" />
              <el-option label="大市场平台" :value="2" />
              <el-option label="成果交易平台" :value="3" />
            </el-select>
        </div>

        <div id="table">
          <!--动态绑定长宽-->
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            type="index"
            @select="tabSelect"
            @select-all="tabSelect"
            :header-cell-style="headerStyle"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column prop="title" label="视频名" align="center"></el-table-column>
            <el-table-column prop="content" label="视频封面" align="center">
              <template slot-scope="scope">
                <img :src="imgUrl + scope.row.album" style="height:45px;width:auto;" />
              </template>
            </el-table-column>

            <el-table-column prop="content" label="视频简介" align="center">
              <template slot-scope="scope">
                <p>{{ replaceNum( scope.row.content, 2) }}</p>
              </template>
            </el-table-column>

            <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
            <el-table-column label="视频属性" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.type > 3 && scope.row.type != 7">点播课程</el-tag>
                <el-tag type="success" v-else>学习课程</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="发布平台" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.isAchievement === 1 && scope.row.isMarket === 1
                    ? '双平台'
                    : scope.row.isMarket === 1
                    ? '大市场平台'
                    : '成果交易平台'
                }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="220">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="current_page"
              :page-size="per_page"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>

    <!-- ---------------------------- 编辑单条记录弹出框 ---------------------------------------------------------- -->
    <el-dialog
      :title="addOrEdit"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="id" prop="id" v-show="false">
          <el-input v-model="ruleForm.id"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-form-item label="视频属性">
              <el-radio-group v-model="type_shu" @change="typeShuEvent">
                <el-radio-button label="学习课程"></el-radio-button>
                <el-radio-button label="点播课程"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="视频类型" prop="type">
              <el-select v-model="ruleForm.type" placeholder="请选择视频类型">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="视频名称" prop="title">
                <el-input v-model="ruleForm.title"></el-input>
              </el-form-item>
              <el-form-item label="创建时间" prop="createTime">
                <el-input :disabled="true" v-model="ruleForm.createTime"></el-input>
              </el-form-item>
              <el-form-item label="上传视频" prop="author" style="margin-bottom: 0;">
                <el-upload
                  class="upload-demo"
                  :action="this.uploadURL"
                  name="file"
                  :on-success="handleFilePreview"
                  :disabled="ruleForm.image == ''"
                  :before-upload="beforeFileHandlePreview"
                  :file-list="fileList"
                  :on-remove="removeFileHandlePreview"
                >
                  <el-button size="small" type="primary" :disabled="ruleForm.image == ''">点击上传</el-button>
                  <span class="mess">注：视频编码格式应为H.264</span>
                </el-upload>
              </el-form-item>
              <span
                class="mess"
                style="padding-left:80px;margin: 5px 0;display: block;"
              >(未上传封面图片的情况下无法上传视频)</span>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="封面" prop="image">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img v-if="ruleForm.image" :src="imgUrl +ruleForm.image" class="img_border" />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.image }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.image">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.image">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label=" " prop="content">
            <editor v-model="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl"></editor>
            <!-- <quill-editor
              :quillData="ruleForm.content"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
              @getQuillData="getQuillData"
            ></quill-editor>-->
          </el-form-item>
        </el-row>
        <el-row>
        <el-form-item label="同步发布" prop="isMarket" style="text-align: left">
          <el-select
            v-model="isMarket"
            placeholder="请选择"
            style="width: 100%"
            @change="formmarket"
          >
            <el-option label="双平台" :value="1" />
            <el-option label="大市场平台" :value="2" />
            <el-option label="成果交易平台" :value="3" />
          </el-select>
        </el-form-item>
        </el-row>
        <el-row style="text-align:right">
          <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- -------------------------------------------------- 分页 ----------------------------------------------------------------- -->
  </div>
</template>

<script>
// import quillEditor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
import CommonLayout from "../../components/common-layout.vue";

export default {
  components: {
    // quillEditor,
    editor,
    CommonLayout,
  },
  data() {
    return {
      is_submit: true,
      srelease:'',
      type_shu_select: "",
      pageSearchUrl: "0,1,2,3,4,5,6,7",
      options: [],
      options_learn: [
        {
          value: 1,
          label: "初级经纪人课程",
        },
        {
          value: 2,
          label: "中级经纪人课程",
        },
        {
          value: 3,
          label: "高级经理人课程",
        },
        {
          value: 7,
          label: "选修课程",
        },
      ],
      options_video: [
        {
          value: 4,
          label: "技术经理人培训",
        },
        {
          value: 5,
          label: "专项推介活动",
        },
        {
          value: 6,
          label: "其他",
        },
      ],
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      fileList: [], //上传文件
      isEdit: false,
      image: "",
      // is_announce: 'true',
      activeName: "1", //tab选项
      cur_page: 1,
      tableData: [], //列表数据
      title_keyWord: "",
      selected: [], //已选行数
      total: 10, //总页数
      current_page: 1, //当前页
      per_page: 20,
      checked: false, //全选框
      checkList: [], //每行单选
      type_shu: "学习课程",
      isMarket:1,
      //编辑弹出表单
      ruleForm: {
        createTime: "",
        content: "",
        type: "",
        image: "",
        author: "",
        isMarket: 1,
        isAchievement: 1,
      },
      addOrEdit: "新增",
      content: "", //编辑的文本内容
      // isHot: false, //是否推荐
      // switchWidth: 75, //是否选择框宽度
      dialogFormVisible: false,
      dialogFormVisible1: false,
      //表单验证规则
      rules: {
        title: [
          {
            required: true,
            message: "标题不能为空",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "视频类型不能为空",
            trigger: "change",
          },
        ],
        author: [
          {
            required: true,
            message: "视频不能为空",
            trigger: "change",
          },
        ],
        image: [
          {
            required: true,
            message: "封面不能为空",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    let this_ = this;
    this.options = this.options_learn;
    this.getData("0,1,2,3,4,5,6,7");
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    selectChange() {
      this.current_page = 1;
      let type = "0,1,2,3,4,5,6,7";
      if (this.type_shu_select == 1) {
        type = "1,2,3,7";
      }
      if (this.type_shu_select == 2) {
        type = "4,5,6";
      }
      this.pageSearchUrl = type;
      this.getData(type);
    },
    typeShuEvent() {
      this.options =
        this.type_shu == "学习课程" ? this.options_learn : this.options_video;
      this.ruleForm.type = "";
    },
    //tabs标签点击事件
    handleClick(type, event) {
      this.getData("0,1,2,3,4,5,6,7");
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.content = val;
    },
    //获取列表数据
    getData(urlType) {

      let params = {
        isShow: 1,
        typeArr: urlType,
        page: this.current_page,
        keyword: this.title_keyWord
      };
      if(this.srelease && this.srelease ===1){
        params.isMarket = 1
        params.isAchievement = 1
      }else if(this.srelease && this.srelease ===2){
        params.isMarket = 1
        params.isAchievement = 2
      }else if(this.srelease){
        params.isMarket = 2
        params.isAchievement = 1
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/on-demand/page`, params)
        .then((response) => {
          let newDate = new Date().getTime();
          this.tableData = response.data.data;
          this.total = response.data.total; //总页数
          this.per_page = response.data.per_page;
          this.current_page = response.data.current_page;
          for (var i in this.tableData) {
            // //转换时间戳到日期格式
            this.tableData[i].type = this.tableData[i].type;
            if (this.tableData[i].createTime.length == 13) {
              this.tableData[i].createTime = this.pbcFun.formatDate(
                new Date(this.tableData[i].createTime * 1),
                "yyyy-MM-dd hh:mm:ss"
              );
            } else if (this.tableData[i].createTime.length == 10) {
              this.tableData[i].createTime = this.pbcFun.formatDate(
                new Date(this.tableData[i].createTime * 1000),
                "yyyy-MM-dd hh:mm:ss"
              );
            } else {
              this.tableData[i].createTime = this.pbcFun.formatDate(
                new Date(this.tableData[i].createTime.slice(13) * 1),
                "yyyy-MM-dd hh:mm:ss"
              );
            }
          }
        });
    },
    //搜索
    search() {
      this.current_page = 1;
      this.getData("0,1,2,3,4,5,6,7");
    },
    //新增
    addNews() {
      this.isEdit = false;
      this.addOrEdit = "新增";
      this.isMarket = 1
      this.dialogFormVisible = true; //打开弹窗
      this.$nextTick(() => {
        this.$refs["ruleForm"].resetFields();
        this.ruleForm = {
          title: "", //视频名
          content: "", //内容介绍
          type: "", //////视频类型
          image: "",
          author: "",
          createTime: this.pbcFun.formatDate(
            new Date(new Date().getTime()),
            "yyyy-MM-dd hh:mm:ss"
          ), //创建时间 /*创建时间赋值为今天日期*/
        };
      });
      this.image = "";
      this.fileList = [];
    },
    //关闭
    close() {
      this.dialogFormVisible1 = false; //打开弹窗
    },
    formmarket(val) {
      if (val === 1) {
        this.ruleForm.isMarket = 1;
        this.ruleForm.isAchievement = 1;
      } else if (val === 2) {
        this.ruleForm.isMarket = 1;
        this.ruleForm.isAchievement = 2;
      } else {
        this.ruleForm.isMarket = 2;
        this.ruleForm.isAchievement = 1;
      }
    },
    //编辑
    handleEdit(e) {
      this.isEdit = true;
      this.addOrEdit = "编辑";
      this.dialogFormVisible = true; //打开弹窗
      this.ruleForm = {
        id: "",
        title: "",
        content: "",
        createTime: "",
        type: "",
        image: "",
        author: "",
        isMarket:1,
        isAchievement:1,
      };
      this.$nextTick(() => {
        this.$refs["ruleForm"].resetFields();
        this.ruleForm.id = e.id;
        this.ruleForm.title = e.title;
        this.ruleForm.content = e.content;
        this.ruleForm.type = e.type;
        this.ruleForm.createTime = this.pbcFun.formatDate(
          new Date(e.createTime),
          "yyyy-MM-dd hh:mm:ss"
        );
        this.ruleForm.image = e.album;
        this.ruleForm.author = e.title;
        this.ruleForm.isMarket = e.isMarket;
        this.ruleForm.isAchievement = e.isAchievement;
        this.options =
          e.type > 3 && e.type != 7 ? this.options_video : this.options_learn;
        this.type_shu = e.type > 3 && e.type != 7 ? "点播课程" : "学习课程";
        this.fileList = [
          {
            name: e.title,
            url: this.imgUrl + e.store_result,
            store_result: e.store_result,
          },
        ];
        this.isMarket =
        this.ruleForm.isAchievement === 1 && this.ruleForm.isMarket === 1
          ? 1
          : this.ruleForm.isMarket === 1
          ? 2
          : 3;
      });
    },
    //上传文件
    handleFilePreview(response, file, fileList) {
      if (response.code == 0) {
        this.ruleForm.author = response.data.store_result;
        this.fileList = [
          {
            name: file.name,
            url: this.imgUrl + response.data.store_result,
            store_result: response.data.store_result,
          },
        ];
      } else {
        this.$message.warning(`上传失败！！！`);
      }
      // console.log(this.fileList);
    },
    beforeFileHandlePreview(file) {
      if (this.fileList.length > 0) {
        this.$message.warning(`当前限制上传 1 个文件`);
        return false;
      }
      let type = false;
      if (file.type === "video/mp4") {
        type = true;
      }
      if (!type) {
        this.$message.error("上传视频只能是MP4格式!");
      }

      return type;
    },
    removeFileHandlePreview(file, fileList) {
      if (file && file.status !== "success") {
        //移除方法

        return false;
      }

      this.fileList = fileList;
      this.$confirm("确定删除文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.fileList = [];
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.ruleForm.image = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },

    handlePictureCardPreview(file) {
      this.ruleForm.image = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function () {
        //          if()
        //          {
        //
        //          }
        console.log("2:", img.width);
      };

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.image = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //提交编辑
    async submitForm(formName) {
      if (this.is_submit) {
        this.is_submit = false;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // if(this.image == ''){
            // 	this.$message.error("请上传");
            // 	return false
            // }
            let data = {
              isMarket:this.ruleForm.isMarket,
              isAchievement:this.ruleForm.isAchievement,
              album:
                typeof this.ruleForm.image == "undefined"
                  ? ""
                  : this.ruleForm.image, //视频封面
              title: this.ruleForm.title, //视频名
              content:
                typeof this.ruleForm.content == "undefined"
                  ? ""
                  : this.ruleForm.content, //点播内容介绍
              album:
                typeof this.ruleForm.image == "undefined"
                  ? ""
                  : this.ruleForm.image, //视频封面
              videoSrc:
                this.fileList.length == 0 ? "" : this.fileList[0].store_result, //视频源
              type:
                typeof this.ruleForm.type == "undefined"
                  ? ""
                  : this.ruleForm.type, //点播内容介绍
              createTime: parseInt(
                new Date(this.ruleForm.createTime).getTime() / 1000
              ), //创建时间
            };
            if (typeof this.ruleForm.id == "undefined") {
              //新增
              this.http
                .post(`${urlConfig.devUrl}apij2/admin-api/trade/on-demand/create`, data)
                .then((response) => {
                  if (response.code == 0) {
                    this.ResetSearch(["title_keyWord", "type_shu_select"]);

                    this.$message.success("添加成功！");
                    this.dialogFormVisible = false; //打开弹窗

                    this.getData("0,1,2,3,4,5,6,7");
                  }
                }).catch(err => {
					this.is_submit = true
				});
            } else {
              //编辑
              data.id = this.ruleForm.id;
              this.http
                .post(`${urlConfig.devUrl}apij2/admin-api/trade/on-demand/update`, data)
                .then((response) => {
                  if (response.code == 0) {
                    this.ResetSearch(["title_keyWord", "type_shu_select"]);

                    this.$message.success("编辑成功！");
                    this.dialogFormVisible = false; //打开弹窗
                    this.getData("0,1,2,3,4,5,6,7");
                  }
                }).catch(err => {
					this.is_submit = true
				});
            }
          } else {
            this.is_submit = true;
          }
        });
      }
    },
    //重置编辑
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    //删除
    handleDelete(e) {
      this.$confirm("确定删除文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/trade/on-demand/delete?id=` + e.id, "", "delete")
            .then(
              (response) => {
                if (response.code == 0) {
                  this.ResetSearch(["title_keyWord", "type_shu_select"]);

                  this.$message.success("删除成功！");
                  this.getData("0,1,2,3,4,5,6,7");
                }
              },
              (error) => {}
            );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除
    deleteAll() {
      if (!this.selected.length) {
        this.$message.warning("请选择一项记录删除 ! ");
        return false;
      }
      this.$confirm("确定删除文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .delete(`${urlConfig.devUrl}apij2/admin-api/trade/on-demand/batchDelete?ids=` + this.selected)
            .then((response) => {
              if (response.code == 0) {
                this.ResetSearch(["title_keyWord", "type_shu_select"]);

                this.$message.success("删除成功！");
                setTimeout(() => {
                  this.cur_page = 1;
                  this.getData("0,1,2,3,4,5,6,7");
                }, 50);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //选择行数
    tabSelect(sec, row) {
      let ids = "";
      for (let i of sec) {
        ids += i.id + ",";
      }
      ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    //替换数字为中文
    replaceNum(data, index) {
      //去掉html标签
      if (index == 2 && data) {
        data = this.GetTarg(data);
      }
      //创建时间
      if (data) {
        if (index == 4 || index == 5 || index == 6) {
          if (data.toString().length < 11)
            data = dataformat.formatDate(
              new Date(Number(data) * 1000),
              "yyyy-MM-dd hh:mm:ss"
            );
          else if (data.toString().length == 13)
            data = dataformat.formatDate(
              new Date(Number(data)),
              "yyyy-MM-dd hh:mm:ss"
            );
        }
      }
      return data;
    },
    //选择页码
    handleCurrentChange(e) {
      this.current_page = e;
      this.getData(this.pageSearchUrl);
    },
    onEditorReady(editor) {
      console.log("editor ready!", editor);
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  word-break: normal;
}

.table_container {
  height: 100%;
  text-align: left;

  .handle-box {
    .handle-input {
      /deep/.el-input__suffix {
        margin-right: 10px;
      }
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      // background-color: #eef1f6 !important;
      // color: #000;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      img {
        max-width: 100px;
        max-height: 100%;
        width: auto;
        height: auto;
      }
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .pagination {
    margin-top: 10px;
  }

  //文本编辑器
  .quill-editor {
    height: 400px;

    /deep/ .ql-container {
      height: calc(100% - 80px) !important;
    }
  }

  .editer {
    padding: 10px 0;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 178px;

    /deep/ .el-upload {
      border: 1px dashed #d9d9d9 !important;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    /deep/ .el-upload:hover {
      border-color: #409eff !important;
    }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  /deep/ .el-dialog__header {
    text-align: center !important;
  }
}

.mess {
  color: red;
  margin-left: 20px;
}
</style>
